module.exports = __webpack_public_path__ + "img/partner.e46a35bd.png";